import { PaczkomatExtendedPoint } from 'helpers/paczkomat/types';
import { PickupPointType } from 'types/pickupPoint';

export function mapPaczkomatExtendedPoint(point: PaczkomatExtendedPoint): PickupPointType {
    return {
        identifier: point.name.toString(),
        name: point.name,
        email: null,
        telephone: point.phone_number ?? null,
        description: point.payment_point_descr ?? '',
        openingHours: null,
        street: mapStreetWithBuildingNumber(point),
        postcode: point.address_details.post_code ?? '',
        city: point.address_details.city,
        country: { code: 'PL', name: 'Polska' },
        disabled: false,
        reservationDisabled: false,
        locationLatitude: null,
        locationLongitude: null,
    };
}

const mapStreetWithBuildingNumber = (point: PaczkomatExtendedPoint): string => {
    let street = point.address_details.street;

    if (point.address_details.building_number !== null && point.address_details.building_number !== undefined) {
        street += ` ${point.address_details.building_number}`;
    }

    return street;
};
